// These are only used for setting the status with the relevant endpoint (not for status representation)
export enum RecurringInvoiceStatusEventType {
  Completed = 'completed',
  Paused = 'paused',
  Started = 'started',
}
